module.exports = __webpack_public_path__ + "img/s-bg-3.97f2ff50.png";